import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="sidebar"
export default class extends Controller {
  static targets = ['sidebar', 'drawer'];

  connect() {
    // Add event listeners for the drawer checkbox
    if (this.hasDrawerTarget) {
      this.drawerTarget.addEventListener(
        'change',
        this.toggleSticky.bind(this)
      );
    }
  }

  disconnect() {
    // Clean up event listeners when controller disconnects
    if (this.hasDrawerTarget) {
      this.drawerTarget.removeEventListener(
        'change',
        this.toggleSticky.bind(this)
      );
    }
  }

  toggleSticky() {
    if (this.hasSidebarTarget) {
      if (this.drawerTarget.checked) {
        // Drawer is open, remove sticky class
        this.sidebarTarget.classList.remove('sticky');
        this.sidebarTarget.classList.remove('fixed');
      } else {
        setTimeout(() => {
          this.sidebarTarget.classList.add('sticky');
          this.sidebarTarget.classList.add('fixed');
        }, 300);
      }
    }
  }

  toggleDrawer() {
    // Find the actual drawer checkbox
    const drawerId =
      this.drawerTarget.getAttribute('data-drawer-id') || 'my-drawer';
    const drawerCheckbox = document.getElementById(drawerId);

    if (drawerCheckbox) {
      // Toggle the drawer checkbox
      drawerCheckbox.checked = !drawerCheckbox.checked;

      // Update our reference target
      if (this.hasDrawerTarget) {
        this.drawerTarget.checked = drawerCheckbox.checked;
      }

      // Toggle sticky class based on drawer state
      if (this.hasSidebarTarget) {
        if (drawerCheckbox.checked) {
          this.sidebarTarget.classList.remove('sticky');
        } else {
          setTimeout(() => {
            this.sidebarTarget.classList.add('sticky');
          }, 300);
        }
      }
    }
  }
}
